<template>
  <div
    id="addBadge"
    class="tab-pane "
    role="tabpanel"
  >
    <!-- .question -->
    <b-form-group
      id="input-group-1"
      :label="$t('examsQuestions.question')"
      label-for="input-1"
    >
      <b-form-input
        id="input-1"
        v-model="newItem.question"
        type="text"
        :placeholder="$t('examsQuestions.question')"
      />
    </b-form-group>
    <!-- .grade -->
    <b-form-group
      id="input-group-2"
      :label="$t('examsQuestions.grade')"
      label-for="input-2"
    >
      <b-form-input
        id="input-2"
        v-model="newItem.grade"
        type="text"
        :placeholder="$t('examsQuestions.grade')"
      />
    </b-form-group>
    <!-- .worthy -->
    <b-form-group
      id="input-group-3"
      :label="$t('examsQuestions.worthy')"
      label-for="input-3"
    >
      <b-form-input
        id="input-3"
        v-model="newItem.worthy"
        type="text"
        :placeholder="$t('examsQuestions.worthy')"
      />
    </b-form-group>
    <!-- .type -->
    <b-form-group
      id="input-group-4"
      :label="$t('examsQuestions.type')"
      label-for="input-4"
    >
      <b-form-input
        id="input-4"
        v-model="newItem.type"
        type="text"
        :placeholder="$t('examsQuestions.type')"
      />
    </b-form-group>
    <!-- .course -->
    <b-form-group
      id="input-group-5"
      :label="$t('examsQuestions.course')"
      label-for="input-5"
    >
      <Select2
        id="input-5"
        v-model="newItem.course"
        :options="courseOptions"
      />
    </b-form-group>
    <div class="form-group">
      <button
        type="button"
        class="btn btn-primary"
        @click="submit()"
      >
        <i class="fa fa-plus" /> {{ $t('site.save') }}
      </button>
    </div>
  </div>
</template>

<script>
import Select2 from 'v-select2-component'
import Controller from '../../../../Controllers/ExamsQuestionsController'
import config from '../../../../config/config'

const controller = new Controller()
export default {
  name: 'ExamsQuestionsForm',
  components: {
    Select2,
  },
  props: ['newItem'],
  data() {
    return {
      file: {},
      
      course: [],

    }
  },
  methods: {
       goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      controller.From(this.newItem, 'FormData')
    },
    // async created() {
    //    const data = await controller.created();
    //    data.
    // },

  },

}
</script>
